import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { $messageCentreStore } from '@lib/store';
import { Button, ErrorMessage, Modal, Text, Textarea } from '@shared/widgets';

interface IForm {
  otherDetails: string;
}
const DEFAULT_VALUES: IForm = { otherDetails: '' };

interface RequestPhysicalDocumentationsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const RequestPhysicalDocumentationsModal = (props: RequestPhysicalDocumentationsModalProps) => {
  const { control, formState, handleSubmit, reset } = useForm<IForm>({ defaultValues: DEFAULT_VALUES });

  const { t } = useTranslation();

  const closeHandler = () => {
    props.onClose();
    reset(DEFAULT_VALUES);
  };
  const submitHandler = async (data: IForm) => {
    $messageCentreStore.events.createNewThreadWithMessage({ subject: 'Request Physical Documentations', body: data.otherDetails, file: undefined });
    closeHandler();
  };
  return (
    <Modal isOpen={props.isOpen} onClose={closeHandler} title='Request Physical Documentations' width='380px'>
      <form className='flex flex-col gap-2' noValidate onSubmit={handleSubmit(submitHandler)}>
        <Text>Please request what documentation you require to be printed. These will be delivered to the registered address.</Text>
        <Controller
          name='otherDetails'
          control={control}
          rules={{ required: t('errors.form.required', { ns: 'common' }) }}
          render={({ field, fieldState: { error } }) => (
            <div>
              <Textarea
                textareaClassName='mb-0'
                fitContent
                label='Other details'
                placeholder='Other details'
                required
                value={field.value}
                onChange={field.onChange}
              />
              <ErrorMessage text={error?.message} />
            </div>
          )}
        />

        <Button className='mt-6' color='primary' type='submit' disabled={formState.isSubmitting}>
          Submit
        </Button>
      </form>
    </Modal>
  );
};
